<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules"
    >
        <CForm @submit.prevent>
            <CInput
                v-model="model.name"
                horizontal
                label="Имя"
                placeholder="Имя курьера"
                :is-valid="errors.name && errors.name.isValid"
            />

            <CInput
                v-model="model.phone"
                horizontal
                label="Номер телефона"
                placeholder="Номер телефона в формате +7XXXXXXXXXX"
                :is-valid="errors.phone && errors.phone.isValid"
            />

            <CInputFile
                ref="photo"
                horizontal
                label="Аватар"
                :is-valid="errors.photo && errors.photo.isValid"
                @change="selectPicture" />

            <CTextarea
                v-model="model.description"
                horizontal
                label="Краткое описание"
                placeholder="Укажите краткое описание (не более 255 символов)"
                :is-valid="errors.description && errors.description.isValid"
                :rows="3"
            />

            <CInput
                v-model="model.tips_layout_id"
                horizontal
                label="ID в системе чаевых (чай-чай)"
                placeholder="ID в системе чаевых (чай-чай)"
            />

            <CInput
                v-model="model.tips_layout_id_new"
                horizontal
                label="ID в системе чаевых (нетмонет)"
                placeholder="ID в системе чаевых (нетмонет)"
                :is-valid="errors.tips_layout_id_new && errors.tips_layout_id_new.isValid"
            />

            <CInput
                v-model="model.max_bot_id"
                horizontal
                label="MAX Chat ID"
                placeholder="ID чата в MAX (привязка бота)"
            />

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3"> Активен </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled"
                    />
                </CCol>
            </CRow>

            <div class="flex mt-4">
                <CButton
                    color="primary"
                    @click="submit"
                >{{ submitButtonTitle }}
                </CButton>
                <CButton
                    v-if="model.id"
                    variant="outline"
                    color="danger"
                    class="ml-4"
                    @click="promptDelete"
                >Удалить
                </CButton>
            </div>
        </CForm>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Действительно удалить? Это действие нельзя будет отменить."
            @confirm="confirmDelete"
        />
    </AppFormValidator>
</template>

<script>
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule } from '@/utils/rules';
    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                model: {},
                schema: {
                    id: 'id',
                    name: 'name',
                    phone: 'phone',
                    photo: 'photo',
                    description: 'description',
                    tips_layout_id_new: 'tips_layout_id_new',
                    max_bot_id: 'max_bot_id',
                    enabled: source => Boolean(source.enabled),
                },
                rules: {
                    name: [requiredRule],
                    phone: [requiredRule],
                    enabled: [requiredRule],
                },
            };
        },

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
        },

        created() {
            this.setModel();
        },

        methods: {
            setModel() {
                this.model = morphism(this.schema, this.entity);
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                // Загружаем картинку
                if (this.selectedPicture) {
                    let formData = new FormData();
                    formData.append('file', this.selectedPicture);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.photo = resp.data.filename;
                }

                const { id, ...payload } = this.model;

                if (typeof id === 'number') {
                    const [err] = await to(this.axios.put(`/couriers/${id}`, payload));
                    if (err) {
                        this.$root.$emit('showError', 'Ошибка. Не удалось сохранить. ' + err);
                        return;
                    }
                } else {
                    const [err] = await to(this.axios.post('/couriers', payload));
                    if (err) {
                        this.$root.$emit('showError', 'Ошибка. Не удалось создать. ' + err);
                        return;
                    }
                }

                this.$emit('success');
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(this.axios.delete(`/couriers/${this.model.id}`));

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка удаления. ' + error);
                }

                this.$emit('deleted');
            },
        },
    };
</script>
<style>
</style>
